<template>
  <div class="step5">
    <p class="text-center step5__text1">
      ご予約情報に間違いがないかお確かめ下さい。
    </p>
    <p class="borderBottom step5__infoTitle">受取日時</p>
    <p class="step5__dateInfo">
      <span class="span">{{ this.reservation.store.title.rendered }}</span>
      にて
      <span class="span"
        >{{ this.reservation.month }}月{{ this.reservation.date }}日({{
          this.reservation.dayOfWeek
        }}){{ this.reservation.time1 }}:{{ this.reservation.time2 }}</span
      >
      ごろ
    </p>
    <p class="borderBottom step5__infoTitle">商品情報</p>
    <div
      v-for="(itemCart, index) in reservation.cart"
      :key="index"
      class="step5--itemList"
    >
      <p class="step5--itemListImg">
        <img v-bind:src="itemCart.image" class="step5--itemListImg--img" />
      </p>
      <div class="step5--itemListInfo">
        <p>{{ itemCart.name }}</p>
        <p class="step5--itemListInfo_price">
          {{ itemCart.number }}個
          {{ itemCart.price | calcTax | addComma }}円（税込）
        </p>
      </div>
      <p class="hiddenSum">{{ itemCart.price * itemCart.number }}</p>
    </div>
    <div class="step5--itemListSum">
      <div class="step5--itemListSum__div">
        <p>小計{{ reservation.sum | calcTax | addComma }}円</p>
        <p class="ml-3">
          内税{{ Math.floor(reservation.sum * 0.08) | addComma }}円
        </p>
      </div>
      <p class="borderBottom__sum step5--itemListSum__total">
        <span class="borderBottom_sum"
          >合計<span class="span_sum">{{
            reservation.sum | calcTax | addComma
          }}</span
          >円</span
        >
      </p>
    </div>
    <p class="borderBottom step5__infoTitle">お客様情報</p>
    <dl>
      <dt>氏名</dt>
      <dd>{{ this.reservation.customer.name1 }}</dd>
      <dt>フリガナ</dt>
      <dd>{{ this.reservation.customer.name2 }}</dd>
      <dt>電話番号</dt>
      <dd>{{ this.reservation.customer.tel }}</dd>
      <dt>メールアドレス</dt>
      <dd>{{ this.reservation.customer.email }}</dd>
      <dt>ご都合のつきやすい時間</dt>
      <dd>{{ this.reservation.customer.contactTime }}</dd>
      <dt>DM希望</dt>
      <dd>{{ this.reservation.customer.dm }}</dd>

      <dt>備考欄</dt>
      <dd>{{ this.reservation.customer.comment }}</dd>
    </dl>
    <p class="numberNotice text-danger">
      ※数が多いご注文の際はご希望にお応えできない場合がございますので、こちらからお電話させていただきます。連絡が取れない際には、キャンセルさせていただく場合がございます。ご了承くださいませ。
    </p>
    <p class="numberNotice text-danger">
      ※メール受信設定をされていないお客様へは、受注確認メールが届かない場合がございます。「web-order-event@g-spoon.co.jp」を受信許可設定された状態でご注文をお願い致します。
    </p>
    <button type="button" @click="next" class="btn">
      この内容で予約する<i class="fas fa-chevron-right"></i>
    </button>
    <p @click="prev(1)" class="a">
      <span><i class="fas fa-chevron-left"></i>お客様情報入力へもどる</span>
    </p>
  </div>
</template>

<script>
export default {
  name: "step5",
  props: [
    "buttonText",
    "step",
    "shops",
    "radioResult",
    "weeks",
    "calData",
    "reservation",
  ],
  filters: {
    addComma: function(val) {
      return String(val).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    },
    calcTax: function(num) {
      return Math.trunc(Number(num) * 1.08);
    },
  },
  methods: {
    next: function() {
      this.$emit("next");
    },
    prev: function(number) {
      this.$emit("prev", number);
    },
    checkBox: function() {
      let checkBox = document.getElementsByName("checkBox");
      if (checkBox[0].checked) {
        this.reservation.flag1 = true;
      } else {
        this.reservation.flag1 = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.step5 {
  padding: 0 15px;
  &__text1 {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.64;
    text-align: center;
    color: #333333;
  }
  &__infoTitle {
    font-size: 18px;
    font-weight: 500;
    line-height: 1.28;
    text-align: left;
    color: #333333;
  }
  &__dateInfo {
    font-size: 18px;
    font-weight: 500;
    line-height: 1.28;
    text-align: center;
    color: #333333;
  }
  &--itemList {
    display: flex;
    border-bottom: 1px solid #ccc;
    margin-top: 15px;
    &Img {
      width: 20%;
      &--img {
        max-width: 100%;
      }
    }
    &Info {
      margin-left: 25px;
      width: 80%;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.64;
      text-align: left;
      color: #333333;
      p {
        @media (max-width: 767.98px) {
          margin-top: 0;
          margin-bottom: 5px;
        }
      }
      &_price {
        text-align: right;
      }
    }
    &Sum {
      margin-left: auto;
      &__div {
        display: flex;
        font-size: 12px;
        font-weight: 500;
        line-height: 1.92;
        text-align: right;
        color: #333333;
        justify-content: flex-end;
      }
      &__total {
        font-size: 16px;
        line-height: 1.44;
        font-weight: bold;
        text-align: right;
        .borderBottom_sum {
          border-bottom: 2px #000 solid;
        }
        span {
          font-size: 21px;
          line-height: 1.1;
          margin-right: 0;
        }
      }
    }
    .hiddenSum {
      display: none;
    }
  }
}
.span {
  font-size: 18px;
  font-weight: bold;
  line-height: 1.28;
  text-align: center;
  color: #333333;
}
.span_sum {
  font-weight: bold;
  margin-right: 15px;
  margin-left: 15px;
}
.borderBottom {
  border-bottom: 1px gray solid;
}
.a {
  color: #000;
  display: block;
  text-align: center;
  margin-top: 15px;
  i {
    margin-right: 5px;
  }
  span {
    border-bottom: 1px #000 solid;
    &:hover {
      opacity: 0.7;
      cursor: pointer;
    }
  }
}
.btn {
  text-align: center;
  display: block;
  margin: 30px auto 0;
  padding: 15px 0;
  background-color: #998018;
  color: #fff;
  width: 80%;
  font-size: 14px;
  font-weight: 500;
  line-height: 2;
  text-align: center;
  color: #ffffff;
  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }
  i {
    margin-left: 25px;
  }
}

dl {
  display: flex;
  flex-wrap: wrap;
  @media (max-width: 767.98px) {
    display: block;
  }
  dt {
    height: 50px;
    width: 40%;
    text-align: left;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.64;
    color: #333333;
    @media (max-width: 767.98px) {
      width: 100%;
      height: 20px;
      margin-top: 10px;
    }
  }
  .dt_add {
    height: 60px;
    @media (max-width: 767.98px) {
      height: 25px;
    }
    span {
      font-size: 10px;
      line-height: 2.3;
    }
  }
  dd {
    height: 50px;
    width: 60%;
    margin: 0;
    text-align: left;
    @media (max-width: 767.98px) {
      width: 100%;
      height: 20px;
    }
  }
  .dd_add {
    height: 60px;
    @media (max-width: 767.98px) {
      height: 50px;
    }
  }
}
</style>
